import React from "react";
import "./Support.css";
import { Layout } from "antd";
import { useTranslation } from "react-i18next";

const { Content } = Layout;

function Support() {
  const { t } = useTranslation("support");

  return (
    <Content className="content-container">
      <div>{t("Support page")}!</div>
      <a
        className="linked-text"
        href="https://support.zoom.us/hc/en-us/articles/201362033-Getting-Started-on-Windows-and-Mac"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("Click here for Zoom support")}
      </a>
    </Content>
  );
}

export default Support;
